/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Базовая модель для табов. Реагирует на нажатие по табу.
   */
  app.TabsBaseItemView = app.View.extend({
    activeTabClass: 'selected',
    inactiveContentClass: 'not_display',
    inactiveTabInnerClass: 'link link_pseudo',
    tabClass: 'sl-tab',
    events: {
      'click .sl-tab': 'tabClick'
    },

    /**
     * Приводим набор табов в начальное состояние
     */
    run: function () {
      this.initSelect();
    },

    initSelect: function () {
      var selected = this.$('.' + this.tabClass + '.' + this.activeTabClass);

      if (!selected.length && location.hash) {
        selected = this.$('.' + this.tabClass + '[data-content-id="' + location.hash + '"]');
      }

      if (!selected.length) {
        selected = this.$('.' + this.tabClass);
      }
      if (selected.length) {
        this.selectTab(selected.first());
      }
    },

    /**
     * Изменение состояния вкладок
     * @param e
     */
    tabClick: function (e) {
      this.selectTab($(e.currentTarget));
    },

    /**
     * Сделать таб активным
     * @param {jQuery} $tab - выбранный таб.
     */
    selectTab: function ($tab) {
      var scrollTop = $(window).scrollTop();
      var that = this;
      // скрываем весь контент и делаем все табы неактивными
      this.$('.' + this.tabClass).each(function () {
        var $tab = $(this),
          $tabContent = that.getTabContent($tab);

        that.hideTab($tab);
        that.hideContent($tabContent);
      });

      // устанавливаем активный таб и показываем его контент
      var $tabContent = this.getTabContent($tab);
      // сохраняем индекс выбранного таба
      this.currentTabIndex = this.getTabIndex($tab);

      this.showTab($tab);
      this.showContent($tabContent);
      this.trigger('tab:selected', $tab, $tabContent);
      $(window).scrollTop(scrollTop);
      $('.owl-carousel').trigger('resize.owl.carousel');
    },

    /**
     * Возвращает jQuery-объект содержимого связанного с табом.
     *
     * @param {jQuery} $tab jQuery-объект таба
     * @returns {jQuery} jQuery-объект содержимого связанного с табом
     */
    getTabContent: function ($tab) {
      // contentId должен быть уникальным на странице
      var selector = $tab.data('contentId');

      return $(selector).first();
    },

    /**
     * Определяет активный таб и возвращает активный блок контента
     * @return {jQuery} активный блок контента
     */
    getSelectedTabContent: function () {
      var $selectedTab = this.$('.' + this.tabClass + '.' + this.activeTabClass);
      return this.getTabContent($selectedTab);
    },

    /**
     * Отображение активного таба
     *
     * @param {jQuery} $tab jQuery-объект таба
     */
    showTab: function ($tab) {
      $tab.addClass(this.activeTabClass);
      $tab.children('span').removeClass(this.inactiveTabInnerClass);
    },

    /**
     * Отображение активного контента таба
     *
     * @param {jQuery} $content jQuery-объект содержимого связанного с табом
     */
    showContent: function ($content) {
      $content.removeClass(this.inactiveContentClass);
    },

    /**
     * Отображение не активного таба
     *
     * @param {jQuery} $tab jQuery-объект таба
     */
    hideTab: function ($tab) {
      $tab.removeClass(this.activeTabClass);
      $tab.children('span').addClass(this.inactiveTabInnerClass);
    },

    /**
     * Отображение не активного контента
     *
     * @param {jQuery} $content jQuery-объект содержимого связанного с табом
     */
    hideContent: function ($content) {
      $content.addClass(this.inactiveContentClass);
    },

    /**
     * Возвращает порядковый номер таба
     * @param $tab {}
     * @returns {number}
     */
    getTabIndex: function ($tab) {
      var $allTabs = this.$('.sl-tab');
      return _.indexOf($allTabs, $tab[0]) || 0;
    },

    /**
     * Получить таб по порядковому номеру
     * @param index
     */
    getTabByIndex: function (index) {
      var $allTabs = this.$('.sl-tab');
      return $allTabs.eq(index);
    }
  });
})(jQuery);

}.call(window));